import { Card } from 'internalLibrary';
import {
  MouseEventHandler,
  PropsWithChildren,
  ReactElement,
  ReactNode,
} from 'react';
import ChevronRightIcon from '../icons/ChevronRightIcon';
import classes from 'classnames';
import InteractiveArea from '../InteractiveArea';
import styles from './OptionCardButton.module.scss';

interface OptionCardButtonProps {
  className?: string;
  classNameTitle?: string;
  classNameEtiquette?: string;
  classNameIconContainer?: string;
  etiquette?: string;
  intent?: 'warning' | 'success' | 'none' | 'info';
  leftIcon?: ReactElement<React.SVGAttributes<SVGElement>>;
  onClick?: MouseEventHandler<HTMLElement>;
  subtitle?: ReactNode;
  title?: ReactNode;
  dataTest?: string;
}

const OptionCardButton = (props: PropsWithChildren<OptionCardButtonProps>) => {
  const {
    etiquette,
    className,
    classNameEtiquette,
    classNameTitle,
    classNameIconContainer,
    intent = 'none',
    leftIcon,
    onClick,
    subtitle,
    title,
  } = props;

  return (
    <InteractiveArea onClick={onClick}>
      <Card className={classes(styles.container, className)} intent={intent}>
        {etiquette && (
          <div
            className={classes(styles.etiquette, classNameEtiquette)}
            data-test="css-Card-Recommended"
          >
            {etiquette}
          </div>
        )}

        {leftIcon && (
          <div
            className={classes(
              styles['left-icon-container'],
              classNameIconContainer,
            )}
          >
            {leftIcon}
          </div>
        )}

        <div className={classes(styles['text-content'])}>
          {title && (
            <span
              className={classes(classNameTitle, styles.title)}
              data-test="css-Card-Title"
            >
              {title}
            </span>
          )}

          {subtitle && (
            <span className={classes(styles.subtitle)}>{subtitle}</span>
          )}
        </div>

        <ChevronRightIcon className={styles.arrow} />
      </Card>
    </InteractiveArea>
  );
};

export default OptionCardButton;
